/** Path-tour transitions — web and mobile providers apply the same state. */

import { parseGrowthFocus, type GrowthFocus } from './hostGrowthGuide';

export type GrowthTourState = {
  active: boolean;
  focus: GrowthFocus | '';
  stepIndex: number;
};

export function emptyGrowthTourState(): GrowthTourState {
  return { active: false, focus: '', stepIndex: 0 };
}

export function startGrowthTour(focus: string): GrowthTourState | null {
  const parsed = parseGrowthFocus(focus);
  if (!parsed) return null;
  return { active: true, focus: parsed, stepIndex: 0 };
}

export function growthTourNext(
  state: GrowthTourState,
  stepCount: number,
): { state: GrowthTourState; finished: boolean } {
  if (state.stepIndex >= stepCount - 1) {
    return { state: emptyGrowthTourState(), finished: true };
  }
  return { state: { ...state, stepIndex: state.stepIndex + 1 }, finished: false };
}

export function growthTourBack(state: GrowthTourState): GrowthTourState {
  return { ...state, stepIndex: Math.max(0, state.stepIndex - 1) };
}

export function parseGrowthTourActive(raw: unknown): { focus: GrowthFocus; stepIndex: number } | null {
  if (!raw || typeof raw !== 'object') return null;
  const parsed = raw as { focus?: unknown; stepIndex?: unknown };
  const focus = parseGrowthFocus(parsed.focus);
  if (!focus) return null;
  const stepIndex = typeof parsed.stepIndex === 'number' ? parsed.stepIndex : 0;
  return { focus, stepIndex };
}

export function growthTourActiveStorageKey(prefix: string, slug: string): string {
  return `${prefix}:${slug}`;
}
